import { io } from 'socket.io-client'

import { API_SOCKET_URL } from 'constants/api'

// Lazy (#4676): the relay requires a global-edit session, so the socket only
// connects when the IRC terminal opens (see useSocket) and is disconnected on
// logout. Non-global users never trigger a handshake.
export const socket = io(API_SOCKET_URL(), {
  autoConnect: false,
  reconnectionDelayMax: 10000,
  withCredentials: true,
})

/**
 * Drop the session-bound connection on logout. socket.io-client buffers
 * emits made while disconnected in `sendBuffer` and flushes them on the next
 * connect(), so commands queued mid-handshake would otherwise replay under a
 * different user's session. (#4676)
 */
export const resetSocket = () => {
  socket.disconnect()
  socket.sendBuffer = []
}
